import { reportError } from '@ms/yammer-telemetry';

import { PromiseThunkAction } from '../types';

import managedApiAction from './managedApiAction';
import { ManagedApiActionOptions, ManagedApiRequest } from './types';

export type ShouldRetry = (error: unknown) => boolean;

export interface RetryOptions {
  readonly retryDelay: number;
  readonly shouldRetry: ShouldRetry;
  readonly retryRequestFields?: Partial<ManagedApiRequest>;
}

type RetryableManagedApiAction = <TResponse>(
  options: ManagedApiActionOptions<TResponse>,
  retryOptions: RetryOptions
) => PromiseThunkAction<void>;

export const retryableManagedApiAction: RetryableManagedApiAction =
  (options, { retryDelay, shouldRetry, retryRequestFields }) =>
  async (dispatch) => {
    try {
      await dispatch(managedApiAction(options));
    } catch (error) {
      return new Promise<void>((resolve, reject) => {
        setTimeout(async () => {
          if (navigator.onLine && shouldRetry(error)) {
            reportError({ error });

            try {
              await dispatch(managedApiAction({ ...options, request: { ...options.request, ...retryRequestFields } }));
              resolve();
            } catch (error2) {
              reject(error2);
            }
          } else {
            reject(error);
          }
        }, retryDelay);
      });
    }
  };
